"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useID = useID;
exports.IDContextProvider = exports.IDContext = exports.componentIdSuffix = exports.nanoidComponentId = void 0;
var _react = _interopRequireWildcard(require("react"));
var _generate = _interopRequireDefault(require("nanoid/non-secure/generate"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function () {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const nanoidComponentId = () => (0, _generate.default)('0123456789abcdefghijklmnopqrstuvwxyz', 8);
exports.nanoidComponentId = nanoidComponentId;
const componentIdSuffix = _ref => {
  let {
    componentId
  } = _ref;
  return componentId;
};
exports.componentIdSuffix = componentIdSuffix;
const IDContext = (0, _react.createContext)();
exports.IDContext = IDContext;
const IDContextProvider = _ref2 => {
  let {
    generateComponentId = nanoidComponentId,
    generateSuffix = componentIdSuffix,
    children
  } = _ref2;
  let registeredIdsRef = (0, _react.useRef)({});
  const generateId = (id, componentId) => {
    let registeredIds = registeredIdsRef.current;
    if (!registeredIds[id]) {
      let generatedId = id;
      registeredIds[id] = {
        [componentId]: generatedId
      };
      return generatedId;
    }
    if (registeredIds[id][componentId]) {
      return registeredIds[id][componentId];
    }
    let count = Object.keys(registeredIds[id]).length;
    let suffix = generateSuffix({
      id,
      componentId,
      count,
      registeredIds
    });
    let generatedId = "".concat(id, "-").concat(suffix);
    registeredIds[id][componentId] = generatedId;
    return generatedId;
  };
  return _react.default.createElement(IDContext.Provider, {
    value: {
      generateId,
      generateComponentId
    }
  }, children);
};
exports.IDContextProvider = IDContextProvider;
function useID() {
  const {
    generateId,
    generateComponentId
  } = (0, _react.useContext)(IDContext);
  const [componentId] = (0, _react.useState)(generateComponentId);
  const [generatedIds, setGeneratedIds] = (0, _react.useState)({});
  return id => {
    if (id in generatedIds) {
      return generatedIds[id];
    }
    const generatedId = generateId(id, componentId);
    setGeneratedIds({
      ...generatedIds,
      [id]: generatedId
    });
    return generatedId;
  };
}